<template>
  <div id="activity">

    <div class="activity-holder">
      <div class="header" :class="{green: mobile}">Recent Activity
        <div class="close" v-if="mobile">
          <v-btn flat fab small @click="routeRemoveQuery('activity')">
            <v-icon medium>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="content">
        <vo-list fill lazy class="list" :itemComponent="'vo-activity-list'" :list="app.activity.list"></vo-list>
      </div>
      <div class="footer">
        <v-btn class="button" flat block @click="routeRemoveQuery('activity')">
          <v-icon large class="icon">mdi-chevron-up</v-icon>
        </v-btn>
      </div>
    </div>

  </div>
</template>
  
<script>

  export default {

    data () {
      return {
        lockout: false
      }
    },

    methods: {


    },

    props: {
      mobile: {

      }
    }

  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  
  #activity {

    .activity-holder {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      .close {
        position: absolute;
        top: 0;
        right: 0;
      }

      .header {
        @include title();
        @include fontPrimary500();
        text-align: center;
        font-size: 16px;
        color: $black54;
        height: 54px;
        line-height: 54px;
        border-bottom: $borderBlack12;
        background: $white;

        &.green {
          background: $primary !important;
          color: $white;
        }
      }

      .content {
        @include scrollable();
        position: absolute;
        top: 54px;
        left: 0;
        right: 0;
        bottom: 48px;
      
        .list {
          width: 100%;
        }

      }

      .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        border-top: $borderBlack12;
        background-color: $white;

        .button {
          margin: 0;
          border-radius: 0;
          color: $black54;
          height: 48px;
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Activity.vue